import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import { white } from "../../../constants/colors";

const useStyles = makeStyles({
  travelCareIconStyles: {
    height: "45px",
    width: "45px",
    borderRadius: "50%",
    backgroundColor: white,
    flexShrink: 0,
  },
  travelCareDesc: {
    fontSize: "14px",
  },
});

const TravelCareItem = ({ item }) => {
  const { travelCareDesc, travelCareIconStyles } = useStyles();
  return (
    <Box display="flex" mb={3}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        className={travelCareIconStyles}
        mr={2}
      >
        <img src={item.icon} alt="travel-care" />
      </Box>
      <Box flexDirection="column" display="flex">
        <Typography variant="body2">{item.label}</Typography>
        {item.info.map((infoItem, idx) => (
          <Box className={travelCareDesc} mt={1} key={idx}>
            <Typography variant="body1">{infoItem}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TravelCareItem;
